import { z } from 'zod';
import { boardParams, endpoint, id, isoDate } from './common';

export const MESSAGE_MAX_LENGTH = 2000;
const cursor = z.string().regex(/^[a-f0-9]{24}$/, 'Invalid message cursor');
export const chatMessage = z.object({
    id: cursor, conversationId: id, userId: id, authorName: z.string(), text: z.string(), createdAt: isoDate,
});
export type ChatMessage = z.infer<typeof chatMessage>;

export const getMessages = endpoint({
    method: 'GET', path: '/boards/:boardId/chat', params: boardParams,
    query: z.object({ before: cursor.optional() }),
    response: z.object({ messages: z.array(chatMessage), nextBefore: cursor.nullable() }),
});
export const sendMessage = endpoint({
    method: 'POST', path: '/boards/:boardId/chat', params: boardParams,
    body: z.object({ text: z.string().trim().min(1, "Message can't be empty").max(MESSAGE_MAX_LENGTH) }),
    response: z.object({ message: chatMessage }),
});
